// Models
// Constants
import { projectManagerAgentId } from "@ms/uno-constants/lib/local/AgentConstants";
import plannerAgentLogo from "@ms/uno-resources/lib/local/images/planneragent-circle.svg";
// Strings
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
/**
 * Project Manager Agent getter
 */ export function getProjectManagerAgent() {
    return {
        displayName: Strings.Project_Manager,
        id: projectManagerAgentId,
        logoUrl: plannerAgentLogo
    };
}
